module.exports = __webpack_public_path__ + "img/again.588e0fab.svg";